namespace Matrix.Data {
    export class AccountModelTargetColumns {
        static columnsKey = 'Data.AccountModelTarget';
    }
}
